module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "select-goods-box",
    attrs: {
      "title": "选择优惠券",
      "visible": _vm.couponsVisible,
      "width": "740px"
    },
    on: {
      "close": _vm.closeDialog
    }
  }, [
    [_c('div', {
      staticStyle: {
        "margin": "15px auto"
      }
    }, [_c('el-input', {
      attrs: {
        "type": "text",
        "placeholder": "请输入优惠券名称",
        "clearable": ""
      },
      model: {
        value: (_vm.params.keyword),
        callback: function($$v) {
          _vm.$set(_vm.params, "keyword", $$v)
        },
        expression: "params.keyword"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-search"
      },
      on: {
        "click": _vm.search
      },
      slot: "append"
    })], 1)], 1), _vm._v(" "), _c('el-transfer', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      attrs: {
        "titles": ['优惠券列表', '已选中'],
        "button-texts": ['移除选择', '添加选择'],
        "data": _vm.couponList
      },
      on: {
        "change": _vm.couponsSelector
      },
      model: {
        value: (_vm.selectedCoupons),
        callback: function($$v) {
          _vm.selectedCoupons = $$v
        },
        expression: "selectedCoupons"
      }
    }, [_c('div', {
      staticClass: "transfer-footer",
      attrs: {
        "slot": "left-footer"
      },
      slot: "left-footer"
    }, [(_vm.total_count > _vm.params.page_size) ? _c('el-pagination', {
      attrs: {
        "small": "",
        "layout": "prev, pager, next",
        "total": _vm.total_count,
        "page-size": _vm.params.page_size
      },
      on: {
        "current-change": _vm.pageChange
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      on: {
        "click": _vm.closeDialog
      }
    }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.couponsComfirm
      }
    }, [_vm._v("确 定")])], 1)]
  ], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0d260958", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d260958"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/coupon_picker/index.vue
// module id = 2458
// module chunks = 0